import { render, staticRenderFns } from "./ProductBrandPicker.vue?vue&type=template&id=27ac1d9b&"
import script from "./ProductBrandPicker.vue?vue&type=script&lang=js&"
export * from "./ProductBrandPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports